<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g opacity=".75"><path d="M2 10H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1H2v8z" opacity=".6" fill="currentColor"/><path d="M5 13H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1H5v8z" fill="currentColor"/></g><path d="M7 6h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering185',
});
</script>
